import { useIsAuthorized } from '@modules/common/components/CanAccess/hooks';
import { PermissionOperation, PermissionResource } from 'generated/graphql';
import { useCallback } from 'react';
import { useGetUser } from 'v2/core/services/user';

export const useCanEditCustomFilter = () => {
  const isAuthorized = useIsAuthorized({
    resource: PermissionResource.AllCustomFilters,
    operation: PermissionOperation.Write,
  });
  const { id } = useGetUser();
  return useCallback(
    (creatorID?: string) => {
      if (creatorID === id) {
        return true;
      }
      return isAuthorized;
    },
    [id, isAuthorized],
  );
};
